import { Carousel } from "shared/components/atoms/Carousel";
import { FreeFortuneTheme } from "shared/models";

import { ThemeCard } from "./ThemeCard";
import { FreeFortuneThemeDetailSchema } from "@miror/types";

export interface Genre {
  name: string;
  thumbnail: string;
  chunk: number;
}

const themeCardImageBasePath = `${process.env.NEXT_PUBLIC_CDN_V2}/無料占い/theme`;

export const genres: Genre[] = [
  { name: "恋愛", thumbnail: `${themeCardImageBasePath}/love.png`, chunk: 3 },
  {
    name: "お相手・結婚",
    thumbnail: `${themeCardImageBasePath}/partner.png`,
    chunk: 4,
  },
  {
    name: "複雑な恋",
    thumbnail: `${themeCardImageBasePath}/complicated_love.png`,
    chunk: 4,
  },
  {
    name: "人生・運勢",
    thumbnail: `${themeCardImageBasePath}/life.png`,
    chunk: 4,
  },
  {
    name: "家族・夫婦",
    thumbnail: `${themeCardImageBasePath}/family.png`,
    chunk: 3,
  },
  {
    name: "キャリア・お金",
    thumbnail: `${themeCardImageBasePath}/career.png`,
    chunk: 3,
  },
];

interface Props {
  themes: FreeFortuneTheme[] | FreeFortuneThemeDetailSchema[];
  className?: string;
}

export const ThemeCards = ({ themes, className }: Props) => {
  return (
    <Carousel
      data={genres}
      renderItem={(data: Genre, index: number) => (
        <ThemeCard genres={genres} genre={data} themes={themes} index={index} />
      )}
      className={className}
    />
  );
};
